import { Component, computed, input, OnInit, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ImageViewerComponent } from '../../../../../../shared/components/image-viewer/image-viewer.component';
import { PdfViewerComponent } from '../../../../../../shared/components/pdf-viewer/pdf-viewer.component';
import { retrieveFileTypeFromS3Url } from '../../_helpers/transactions-helpers';
import { NgClass } from '@angular/common';
import { calcConditionalEnvBasedUrl } from '../../_helpers/localstack-url-helper';

@Component({
  selector: 'app-receipt-preview',
  imports: [FormsModule, ImageViewerComponent, PdfViewerComponent, NgClass],
  templateUrl: './receipt-preview.component.html',
  styleUrl: '../../../../../../../static/styles/components/receipt-preview.component.scss',
})
export class ReceiptPreviewComponent implements OnInit {
  // Inputs
  receiptUrl = input<string>(''); // Default to empty string
  isPdf = signal<boolean>(false);
  isImage = signal<boolean>(false);
  closePreview = output<void>();

  // Fixed URL for LocalStack support (computed from receiptUrl)
  conditionalEnvReceiptUrl = computed(() => calcConditionalEnvBasedUrl(this.receiptUrl()));

  ngOnInit(): void {
    const filetype = retrieveFileTypeFromS3Url(this.receiptUrl());
    if (filetype === 'pdf') {
      this.isPdf.set(true);
    }
    if (filetype === 'image') {
      this.isImage.set(true);
    }
  }

  onClose(): void {
    this.closePreview.emit();
  }
}
